import { PollyLanguageList } from '@voicefoundry-cloud/vf-storybook';
export const pollyLanguageList = PollyLanguageList;
